var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"centerArea_wrapper"},[_c('Conference',{attrs:{"conference":_vm.hall,"is-room":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }